// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dialog[data-v-7863b8ba] {
      position: absolute;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      --tw-bg-opacity: 1;
      background-color: rgb(255 255 255 / var(--tw-bg-opacity));
      --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
      --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
@media (min-width: 768px) {
.dialog[data-v-7863b8ba] {
            position: static;
            border-radius: 30px
}
}
.dialog[data-v-7863b8ba] {
      max-height: 100%;
      min-height: 12rem;
      max-width: none
}
@media (min-width: 768px) {
.dialog[data-v-7863b8ba] {
            max-width: 28rem
}
}
.dialog[data-v-7863b8ba] {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0
}
@media (min-width: 768px) {
.dialog[data-v-7863b8ba] {
            top: auto;
            bottom: auto;
            left: auto;
            right: auto
}
}
.dialog.large[data-v-7863b8ba] {
      max-width: 48rem
}
@media (min-width: 768px) {
.dialog.spaced[data-v-7863b8ba] {
            min-height: 14rem
}
}
.dialog.maximized[data-v-7863b8ba] {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      max-width: none;
      border-radius: 0px
}
.dialog__backdrop[data-v-7863b8ba] {
      z-index: 30
}
@media (min-width: 768px) {
.dialog__backdrop.padding[data-v-7863b8ba] {
            padding: 2.5rem
}
}
.dialog__wrapper[data-v-7863b8ba] {
      position: relative;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center
}
.dialog__header[data-v-7863b8ba],
  .dialog__footer[data-v-7863b8ba] {
      display: flex;
      flex-grow: 1;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding-left: 1.5rem;
      padding-right: 1.5rem
}
@media (min-width: 768px) {
.dialog__header[data-v-7863b8ba],
  .dialog__footer[data-v-7863b8ba] {
            padding-left: 1.5rem;
            padding-right: 1.5rem
}
.spaced .dialog__header[data-v-7863b8ba], .spaced .dialog__footer[data-v-7863b8ba] {
            padding-left: 2.5rem;
            padding-right: 2.5rem
}
}
.dialog__header[data-v-7863b8ba] {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between
}
@media (min-width: 768px) {
.dialog__header[data-v-7863b8ba] {
            padding-top: 1.5rem;
            padding-bottom: 1rem
}
}
.spaced .dialog__header[data-v-7863b8ba] {
      padding-top: 1.5rem;
      padding-bottom: 1rem
}
@media (min-width: 768px) {
.spaced .dialog__header[data-v-7863b8ba] {
            padding-top: 2.5rem;
            padding-bottom: 1.5rem
}
}
.dialog__header__title[data-v-7863b8ba] {
      margin: 0;
      font-family: Mont;
      line-height: 1.35;
      font-size: 1.5rem;
      font-weight: 400
}
@media (min-width: 768px) {
.dialog__header__title[data-v-7863b8ba] {
            font-family: Mont;
            line-height: 1;
            font-size: 2rem;
            font-weight: 600
}
}
.dialog__header__title.sm[data-v-7863b8ba] {
      font-family: Mont;
      line-height: 1.35;
      font-size: 1.375rem;
      font-weight: 700
}
@media (min-width: 768px) {
.dialog__footer[data-v-7863b8ba] {
            padding-bottom: 1.5rem;
            padding-top: 1rem
}
}
.dialog__footer--sticky[data-v-7863b8ba] {
      position: sticky;
      bottom: 0;
      flex: none;
      padding: 1rem;
      box-shadow: 0px -2px 2px 0px rgba(0, 0, 0, 0.15)
}
.spaced .dialog__footer[data-v-7863b8ba] {
      padding-bottom: 1.5rem;
      padding-top: 1rem
}
@media (min-width: 768px) {
.spaced .dialog__footer[data-v-7863b8ba] {
            padding-bottom: 2.5rem;
            padding-top: 1.5rem
}
}
.dialog__body[data-v-7863b8ba] {
      flex-grow: 1;
      overflow: hidden
}
.dialog__body__scroll[data-v-7863b8ba] {
      height: 100%;
      width: 100%
}
.dialog__body__content[data-v-7863b8ba] {
      padding-left: 1.5rem;
      padding-right: 1.5rem
}
@media (min-width: 768px) {
.spaced .dialog__body__content[data-v-7863b8ba] {
            padding-left: 2.5rem;
            padding-right: 2.5rem
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/dialogs/Dialog.vue"],"names":[],"mappings":";AA8CA;MAAA,kBAAA;MAAA,aAAA;MAAA,sBAAA;MAAA,gBAAA;MAAA,kBAAA;MAAA,yDAAA;MAAA,gFAAA;MAAA,oGAAA;MAAA;AAAA;AAAA;AAAA;YAAA,gBAAA;YAAA;AAAA;AAAA;AACA;MAAA,gBAAA;MAAA,iBAAA;MAAA;AAAA;AAAA;AAAA;YAAA;AAAA;AAAA;AACA;MAAA,MAAA;MAAA,SAAA;MAAA,OAAA;MAAA;AAAA;AAAA;AAAA;YAAA,SAAA;YAAA,YAAA;YAAA,UAAA;YAAA;AAAA;AAAA;AAGA;MAAA;AAAA;AAIA;AAAA;YAAA;AAAA;AAAA;AAIA;MAAA,kBAAA;MAAA,MAAA;MAAA,SAAA;MAAA,OAAA;MAAA,QAAA;MAAA,eAAA;MACA;AADA;AAKA;MAAA;AAAA;AAEA;AAAA;YAAA;AAAA;AAAA;AAKA;MAAA,kBAAA;MAAA,YAAA;MAAA,WAAA;MACA,aAAA;MAAA,sBAAA;MAAA,mBAAA;MAAA;AADA;AAMA;;MAAA,aAAA;MAAA,YAAA;MAAA,mBAAA;MAAA,mBAAA;MAAA,8BAAA;MAAA,oBAAA;MAAA;AAAA;AAAA;AAAA;;YAAA,oBAAA;YAAA;AAAA;AAGA;YAAA,oBAAA;YAAA;AAAA;AAHA;AAQA;MAAA,aAAA;MAAA,mBAAA;MAAA,mBAAA;MAAA;AAAA;AAAA;AAAA;YAAA,mBAAA;YAAA;AAAA;AAAA;AAGA;MAAA,mBAAA;MAAA;AAAA;AAAA;AAAA;YAAA,mBAAA;YAAA;AAAA;AAAA;AAIA;MAAA,SAAA;MAAA,iBAAA;MAAA,iBAAA;MAAA,iBAAA;MAAA;AAAA;AAAA;AAAA;YAAA,iBAAA;YAAA,cAAA;YAAA,eAAA;YAAA;AAAA;AAAA;AAGA;MAAA,iBAAA;MAAA,iBAAA;MAAA,mBAAA;MAAA;AAAA;AAMA;AAAA;YAAA,sBAAA;YAAA;AAAA;AAAA;AAGA;MAAA,gBAAA;MAAA,SAAA;MAAA,UAAA;MAAA,aAAA;MACA;AADA;AAKA;MAAA,sBAAA;MAAA;AAAA;AAAA;AAAA;YAAA,sBAAA;YAAA;AAAA;AAAA;AAKA;MAAA,YAAA;MAAA;AAAA;AAGA;MAAA,YAAA;MAAA;AAAA;AAIA;MAAA,oBAAA;MAAA;AAAA;AAGA;AAAA;YAAA,oBAAA;YAAA;AAAA;AAAA","sourcesContent":["<template>\n  <DialogBackdrop v-if=\"show\" :class=\"['dialog__backdrop', { padding }]\" @mousedown.native=\"handleBackdropClick\">\n    <!-- Wrapper -->\n    <div class=\"dialog__wrapper\">\n      <Animation :duration=\"350\" :enter=\"{ xs: 'slideInUp', md: 'zoomIn' }\" appear>\n        <!-- Dialog -->\n        <div :class=\"['dialog', contentClass, { large, maximized, spaced }]\" :style=\"contentStyle\" @mousedown.stop>\n          <!-- Header -->\n          <DialogHeader class=\"dialog__header\">\n            <!-- Close button -->\n            <IconButton v-if=\"back\" name=\"arrow-left\" :size=\"18\" @click.native=\"onDialogCancel\" />\n\n            <!-- Title -->\n            <template v-if=\"!!title\">\n              <h1 class=\"dialog__header__title\" :class=\"[ titleSize ]\">{{ title }}</h1>\n            </template>\n\n            <!-- Close button -->\n            <IconButton v-if=\"closable\" name=\"close\" :size=\"18\" @click.native=\"show = false\" />\n          </DialogHeader>\n\n          <!-- Body -->\n          <DialogBody class=\"dialog__body\">\n            <ScrollArea :shadow=\"scrollShadow\" class=\"dialog__body__scroll\">\n              <div class=\"dialog__body__content\">\n                <slot />\n              </div>\n            </ScrollArea>\n          </DialogBody>\n\n          <!-- Footer -->\n          <DialogFooter v-if=\"footer\" class=\"dialog__footer\" :class=\"{ 'dialog__footer--sticky': footerSticky }\">\n            <slot name=\"footer\">\n              <IconButton v-if=\"footerClose && !back\" btn-style=\"secondary\" name=\"close\" btn-size=\"sm\" :size=\"14\" type=\"stroke\" :color=\"NEUTRAL_SUPERDARK\" circular @click.native=\"show = false\"></IconButton>\n              <IconButton v-else-if=\"footerClose\" btn-style=\"secondary\" name=\"arrow-left\" btn-size=\"sm\" :size=\"14\" type=\"solid\" :color=\"NEUTRAL_SUPERDARK\" circular @click.native=\"onDialogCancel\"></IconButton>\n              <Button v-else btn-style=\"primary\" @click.native=\"onDialogOk\">Aceptar</Button>\n            </slot>\n          </DialogFooter>\n        </div>\n      </Animation>\n    </div>\n  </DialogBackdrop>\n</template>\n\n<style lang=\"postcss\" scoped>\n.dialog {\n  @apply absolute md:static flex flex-col bg-neutral-white md:rounded-lg shadow-xl overflow-hidden;\n  @apply max-w-none md:max-w-md max-h-full min-h-[12rem];\n  @apply top-0 bottom-0 left-0 right-0 md:top-auto md:bottom-auto md:left-auto md:right-auto;\n\n  &.large {\n    @apply max-w-3xl;\n  }\n\n  &.spaced {\n    @apply md:min-h-[14rem];\n  }\n\n  &.maximized {\n    @apply absolute top-0 bottom-0 left-0 right-0 max-w-none;\n    @apply rounded-none;\n  }\n\n  &__backdrop {\n    @apply z-30;\n    &.padding {\n      @apply md:p-sm;\n    }\n  }\n\n  &__wrapper {\n    @apply relative w-full h-full;\n    @apply flex flex-col justify-center items-center;\n  }\n\n  &__header,\n  &__footer {\n    @apply grow px-xxs md:px-xxs flex flex-row justify-between items-center;\n\n    .spaced & {\n      @apply md:px-sm;\n    }\n  }\n\n  &__header {\n    @apply md:pt-xxs md:pb-xxxs flex flex-row justify-between items-center;\n\n    .spaced & {\n      @apply pt-xxs pb-xxxs md:pt-sm md:pb-xxs;\n    }\n\n    &__title {\n      @apply style-subtitle md:style-title-xs m-0;\n\n      &.sm {\n        @apply style-subtitle-sm-bold;\n      }\n    }\n  }\n\n  &__footer {\n    @apply md:pb-xxs md:pt-xxxs;\n\n    &--sticky {\n      @apply sticky bottom-0 p-xxxs flex-none;\n      box-shadow: 0px -2px 2px 0px rgba(0, 0, 0, 0.15);\n    }\n\n    .spaced & {\n      @apply pb-xxs pt-xxxs md:pb-sm md:pt-xxs;\n    }\n  }\n\n  &__body {\n    @apply grow overflow-hidden;\n\n    &__scroll {\n      @apply w-full h-full;\n    }\n\n    &__content {\n      @apply px-xxs;\n\n      .spaced & {\n        @apply md:px-sm;\n      }\n    }\n  }\n}\n</style>\n\n<script>\nimport { ref, toRefs, watch } from '@vue/composition-api';\nimport { getColor } from '@/lego/utils/tailwind/config';\nimport DialogBackdrop from '@/lego/components/dialogs/DialogBackdrop.vue';\nimport DialogHeader from '@/lego/components/dialogs/DialogHeader.vue';\nimport DialogBody from '@/lego/components/dialogs/DialogBody.vue';\nimport DialogFooter from '@/lego/components/dialogs/DialogFooter.vue';\nimport Animation from '@/lego/components/tools/Animation.vue';\nimport IconButton from '@/lego/components/buttons/IconButton.vue';\nimport Button from '@/lego/components/buttons/Button.vue';\nimport ScrollArea from '@/lego/components/layout/ScrollArea.vue';\n\nconst NEUTRAL_SUPERDARK = getColor('neutral.superdark');\n\nexport default {\n  name: 'DialogComponent',\n\n  components: {\n    DialogBackdrop,\n    DialogHeader,\n    DialogBody,\n    DialogFooter,\n    ScrollArea,\n    Animation,\n    IconButton,\n    Button,\n  },\n\n  props: {\n    value: {\n      type: Boolean,\n      default: true,\n    },\n\n    large: {\n      type: Boolean,\n      default: false,\n    },\n\n    maximized: {\n      type: Boolean,\n      default: false,\n    },\n\n    spaced: {\n      type: Boolean,\n      default: false,\n    },\n\n    padding: {\n      type: Boolean,\n      default: false,\n    },\n\n    persistent: {\n      type: Boolean,\n      default: false,\n    },\n\n    closable: {\n      type: Boolean,\n      default: true,\n    },\n\n    title: {\n      type: String,\n      required: false,\n    },\n\n    titleSize: {\n      type: String,\n      required: false,\n    },\n\n    scrollShadow: {\n      type: Boolean,\n      default: false,\n    },\n\n    contentClass: {\n      type: [String, Array],\n      required: false,\n    },\n\n    contentStyle: {\n      type: [String, Object],\n      required: false,\n    },\n\n    footer: {\n      type: Boolean,\n      default: true,\n    },\n\n    back: {\n      type: Boolean,\n      default: false,\n    },\n\n    footerSticky: {\n      type: Boolean,\n      default: false,\n    },\n\n    footerClose: {\n      type: Boolean,\n      default: false,\n    },\n  },\n\n  setup(props, { emit }) {\n    const { value, persistent } = toRefs(props);\n    const show = ref(value.value);\n\n    function handleBackdropClick() {\n      if (!persistent.value) {\n        show.value = false;\n      }\n    }\n\n    watch(value, val => (show.value = val));\n\n    watch(show, val => {\n      if (!val) {\n        onDialogDismiss();\n      }\n\n      emit('input', val);\n    });\n\n    const onDialogOk = evt => {\n      emit('ok', evt);\n      show.value = false;\n    };\n\n    const onDialogCancel = evt => {\n      emit('cancel', evt);\n      show.value = false;\n    };\n\n    const onDialogDismiss = () => {\n      emit('dismiss');\n    };\n\n    return {\n      NEUTRAL_SUPERDARK,\n      show,\n      handleBackdropClick,\n      onDialogOk,\n      onDialogCancel,\n    };\n  },\n};\n</script>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
